module.exports = __webpack_public_path__ + "static/media/full-screen-icon.896f78ed.svg";